
import './App.css';
import MainParentComponent from './Component/MainParentComponent/MainParentComponent';
import HeaderComponent from './Component/HeaderComponent/HeaderComponent';

function App() {
  return (
    <div className="App">
      <HeaderComponent></HeaderComponent>
      <MainParentComponent></MainParentComponent>
      
    </div>
  );
}

export default App;
